import * as React from 'react';
import progressStyle from '@patternfly/react-styles/css/components/Progress/progress';
import { css } from '@patternfly/react-styles';
import CheckCircleIcon from '@patternfly/react-icons/dist/js/icons/check-circle-icon';
import TimesCircleIcon from '@patternfly/react-icons/dist/js/icons/times-circle-icon';
import { ProgressBar } from './ProgressBar';
export var ProgressMeasureLocation;

(function (ProgressMeasureLocation) {
  ProgressMeasureLocation["outside"] = "outside";
  ProgressMeasureLocation["inside"] = "inside";
  ProgressMeasureLocation["top"] = "top";
  ProgressMeasureLocation["none"] = "none";
})(ProgressMeasureLocation || (ProgressMeasureLocation = {}));

export var ProgressVariant;

(function (ProgressVariant) {
  ProgressVariant["danger"] = "danger";
  ProgressVariant["success"] = "success";
})(ProgressVariant || (ProgressVariant = {}));

var variantToIcon = {
  danger: TimesCircleIcon,
  success: CheckCircleIcon
};
export var ProgressContainer = function ProgressContainer(_ref) {
  var progressBarAriaProps = _ref.progressBarAriaProps,
      value = _ref.value,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      parentId = _ref.parentId,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? null : _ref$label,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? null : _ref$variant,
      _ref$measureLocation = _ref.measureLocation,
      measureLocation = _ref$measureLocation === void 0 ? ProgressMeasureLocation.top : _ref$measureLocation;
  var StatusIcon = variantToIcon.hasOwnProperty(variant) && variantToIcon[variant];
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: css(progressStyle.progressDescription),
    id: "".concat(parentId, "-description"),
    "aria-hidden": "true"
  }, title), React.createElement("div", {
    className: css(progressStyle.progressStatus),
    "aria-hidden": "true"
  }, (measureLocation === ProgressMeasureLocation.top || measureLocation === ProgressMeasureLocation.outside) && React.createElement("span", {
    className: css(progressStyle.progressMeasure)
  }, label || "".concat(value, "%")), variantToIcon.hasOwnProperty(variant) && React.createElement("span", {
    className: css(progressStyle.progressStatusIcon)
  }, React.createElement(StatusIcon, null))), React.createElement(ProgressBar, {
    role: "progressbar",
    progressBarAriaProps: progressBarAriaProps,
    value: value
  }, measureLocation === ProgressMeasureLocation.inside && "".concat(value, "%")));
};